module.exports = __webpack_public_path__ + "assets/img/banner3.3a14222e.png";